import React from "react";
import useToolbarStore from "@/store/toolbarOpenStore";
import { closeToolbarIcon, openToolbarIcon } from "../../icons/SVGIcons";
import SVGandTextContainer from "./SVGandTextContainer";

function ToggleToolbarOpen() {
  const toggleToolbarOpen = useToolbarStore((state) => state.toggleState);
  return toggleToolbarOpen;
}

const ToolbarButton = ({ toolbarOpen }: { toolbarOpen: boolean }) => {
  // Function to toggle the toolbar state
  const toggleToolbarOpen = ToggleToolbarOpen(); // Call the function to get the setter function

  return (
    <div onClick={toggleToolbarOpen} id="SVGToolbarToggle ">
      <SVGandTextContainer
        tooltipID={"SidebarToggle"}
        SVGIcon={toolbarOpen ? closeToolbarIcon : openToolbarIcon}
        toolbarOpen={toolbarOpen}
        openText={""}
      />
    </div>
  );
};

export default ToolbarButton;
